export default function usePage() {
  const { story } = storeToRefs(useStoryProviderStore())

  const title = computed(() => story.value?.name || '')
  const publishedAt = computed(() => story.value?.published_at)
  const firstPublishedAt = computed(() => story.value?.first_published_at)
  const displayDate = computed(() =>
    showFirstPublished.value ? firstPublishedAt.value : publishedAt.value,
  )

  const showFirstPublished = computed(
    () => story.value?.content?.component === 'News',
  )
  const shouldShowStickyNavigation = computed(
    () => story.value?.content?.shouldShowPageNavigation,
  )
  return {
    title,
    publishedAt,
    firstPublishedAt,
    displayDate,
    showFirstPublished,
    shouldShowStickyNavigation,
  }
}
